export function target() {
  return (
    this.module === 'PromoList' && this.data.randomizeList && !this.data.orderBy
  );
}

export function migrate() {
  this.data.orderBy = 'random';

  delete this.data.randomizeList;
}
